var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iframe-tabs"},[_c('iframe',{staticClass:"iframe-class",attrs:{"seamless":"seamless","src":_vm.getIframeSrc,"allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }